
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';

export default defineComponent({
	name: 'text-my',

	props: {
		message: {
			type: Object as PropType<Message>
		}
	}
});
